import React, { Component } from 'react';
import Modal from './_Modal';
import styled from 'styled-components';

const Buttons = styled.div`
  text-align: center;
  margin-top: 15px;
  button {
    background-color: #69f;
    border: none;
    border-radius: 5px;
    margin: 20px;
    color: white;
    &:hover {
      background-color: #36e;
    }
  }
`

class SigninModal extends Component {
  // componentWillReceiveProps(nextProps) {
  //   if (nextProps.open) {
  //     setTimeout(() => {
  //       nextProps.closeModal(nextProps.method)
  //     }, 1000);
  //   }
  // }
  onSignin = () => {
    this.props.signIn()
  }
  render() {
    return (
      <Modal
        open={this.props.open}
        close={() => this.props.closeModal(this.props.method)}
      >
          <h3>Please log in first</h3>
          <hr />
          <Buttons>
            <button onClick={() => this.props.closeModal(this.props.method)}>
              Cancel
            </button>
            <button onClick={() => {this.props.signIn(); this.props.closeModal(this.props.method)}}>Log In</button>
          </Buttons>

      </Modal>
    )
  }
}

export default SigninModal;



// WEBPACK FOOTER //
// ./src/_SigninModal.js